module.exports = __webpack_public_path__ + "img/xsckxx.c20c8a1f.png";